import React, {Component} from 'react';
import {AutocompleteSearch} from "cw-styleguide-react";
import {withTranslation} from "react-i18next";

class SecondaryAutocompleteSearch extends Component {
  render() {
    return (
          <AutocompleteSearch
            title={this.props.t('secondary_search_title')}
            label={this.props.t('secondary_search_label')}
            placeholder={this.props.t('secondary_search_placeholder')}
            heading='h2'
            data={this.props.jobs}
          />
    )
  }
}

export default withTranslation('local')(SecondaryAutocompleteSearch);
